import { MiniSitesConstants } from "../constants/MiniSitesConstants";
import { MiniSitesServices } from "../services/MiniSitesServices";

export const MiniSitesActions = {
    fetchMiniSiteGetListDomain,
    fetchMiniSiteGetIsValidSubdomain,
    fetchMiniSiteSetAttributes,
    fetchMiniSiteSetAttributesHtml,
    fetchMiniSiteGetListEvents,
    fetchMiniSiteSetAttributesSelectListEvents,
    fetchMiniSiteSave,
    fetchMiniSiteSetActiveStep,
    fetchMiniSiteGetBackOfficeUrl,
    fetchMiniSiteReloadComponet,
    fetchMiniSiteGetListMiniSites,
    fetchMiniSiteGetMiniSite,
    fetchMiniSiteSearchEvents,
    fetchMiniSiteSetSelectListEventsNew,
    fetchMiniSiteSearchNotifications,
    fetchMiniSiteSetSelectListNotifications,
    fetchMiniSiteUpdateMiniSite,
    fetchMiniSiteClear
};

function fetchMiniSiteGetListDomain() {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getListDomain()
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_DOMAIN_SUCCESS,
            payload: data,
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteGetIsValidSubdomain(dataRequest) {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.isValidSubdomain(dataRequest)
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        if (data.data) {
            return {
                type: MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_INVALID,
                activeStep: 0
            }
        } else {
            return {
                type: MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID_SUBDOMAIN_SUCCESS,
                activeStep: 1
            }
        }

    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteSetAttributes(newAttributes) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(newAttributes));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(newAttributes) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES,
            payload: newAttributes,
        };
    }
}

function fetchMiniSiteSetAttributesHtml(newAttributes) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(newAttributes));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(newAttributes) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_HTML,
            payload: newAttributes,
        };
    }
}

function fetchMiniSiteGetListEvents(dataRequest) {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getListEvents(dataRequest)
            .then(
                data => dispatch(success(data, dataRequest)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data, dataRequest) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_EVENTS_SUCCESS,
            payload: data
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteSetAttributesSelectListEvents(dataSelectContent) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(dataSelectContent));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(dataSelectContent) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENTS_SUCCESS,
            payload: dataSelectContent,
        };
    }
}

function fetchMiniSiteSetActiveStep(activeStep, dataBasicDetails) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(activeStep, dataBasicDetails));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_RELOAD_COMPONENT
        };
    }

    function success(activeStep, dataBasicDetails) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ACTIVE_STEP,
            payload: dataBasicDetails,
            activeStep: activeStep
        };
    }
}

function fetchMiniSiteSave(history, dataRequest) {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.saveMiniSites(dataRequest)
            .then(
                data => dispatch(success(data, history)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data, history) {

        history.push('/LayoutMiniSite/List')
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SAVE_SUCCESS,
            payload: data.data,
            activeStep: 1,
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteGetBackOfficeUrl() {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getBackofficeUrl()
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_BACKOFFICE_URL_SUCCESS,
            payload: data.data.urlBackofficeBase,
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteReloadComponet() {

    return dispatch => {
        dispatch(request());
        return dispatch(success());
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_RELOAD_COMPONENT,
            payload: true
        };
    }

    function success() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_RELOAD_STOP_COMPONENT,
            payload: false
        };
    }
}

function fetchMiniSiteGetListMiniSites(dataRequest) {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getListMiniSites(dataRequest)
            .then(
                data => dispatch(success(data, dataRequest)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_MINISITES_SUCCESS,
            payload: data
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteGetMiniSite(dataRequest) {
    return dispatch => {
        dispatch(request());

        MiniSitesServices.getListDomain()
            .then(
                data => dispatch(success1(data)),
                error => dispatch(failure(error))
            );

        MiniSitesServices.getBackofficeUrl()
            .then(
                data => dispatch(success2(data)),
                error => dispatch(failure(error))
            );

        MiniSitesServices.getMiniSite(dataRequest)
            .then(
                data => dispatch(success(data, dataRequest)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_MINISITE_SUCCESS,
            payload: data.data
        };
    }

    function success1(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_LIST_DOMAIN_SUCCESS,
            payload: data,
        };
    }

    function success2(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_GET_BACKOFFICE_URL_SUCCESS,
            payload: data.data.urlBackofficeBase,
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteSearchEvents(dataRequest) {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getSearchEvents(dataRequest)
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SEARCH_EVENTS_SUCCESS,
            payload: data.data
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteSetSelectListEventsNew(searchResultListEvents, selectListEventsNew, errors) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(searchResultListEvents, selectListEventsNew, errors));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(searchResultListEvents, selectListEventsNew, errors) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_EVENT,
            payload: selectListEventsNew,
            payload2: searchResultListEvents,
            errors: errors
        };
    }
}

function fetchMiniSiteSearchNotifications() {
    return dispatch => {
        dispatch(request());
        MiniSitesServices.getSearchNotifications()
            .then(
                data => dispatch(success(data)),
                error => dispatch(failure(error))
            );
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(data) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SEARCH_NOTIFICATIONS_SUCCESS,
            payload: data.data
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteSetSelectListNotifications(searchResultListNotifications, selectListNotifications, errors) {

    return dispatch => {
        dispatch(request());
        return dispatch(success(searchResultListNotifications, selectListNotifications, errors));
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success(searchResultListNotifications, selectListNotifications) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_SET_ATTRIBUTES_SELECT_LIST_NOTIFICATIONS,
            payload: selectListNotifications,
            payload2: searchResultListNotifications,
            errors: errors
        };
    }
}

function fetchMiniSiteUpdateMiniSite(history, dataRequest) {
    return dispatch => {
        dispatch(request());

        let subdomainCompare = dataRequest.dataBasicDetails.subdomain.concat(".").concat(dataRequest.dataBasicDetails.domain);
        const requestToUpdate = new FormData();
        requestToUpdate.append('idMinisite', dataRequest.idMinisite);
        requestToUpdate.append('name', dataRequest.dataBasicDetails.name);
        requestToUpdate.append('domainName', subdomainCompare);
        requestToUpdate.append('logoURL', dataRequest.dataBasicDetails.minisiteLogoUrl);
        requestToUpdate.append('files', dataRequest.dataBasicDetails.minisiteLogo);
        requestToUpdate.append('header_minisite', dataRequest.dataNotofications.header);
        requestToUpdate.append('footer_minisite', dataRequest.dataNotofications.footer);

        for (var i = 0; i < dataRequest.dataSelectContent.selectListEventsNew.length; i++) {
            requestToUpdate.append('selectListEvents', dataRequest.dataSelectContent.selectListEventsNew[i].ID);
        }

        for (var j = 0; j < dataRequest.dataNotificationContent.selectListNotifications.length; j++) {
            requestToUpdate.append('selectListMandrillTemplates', dataRequest.dataNotificationContent.selectListNotifications[j].ID);
        }

        if (subdomainCompare.localeCompare(dataRequest.dataBasicDetails.domainName) !== 0) {
            let request = {
                subdomainCompare: subdomainCompare
            };
            MiniSitesServices.isValidSubdomain(request)
                .then(
                    data => dispatch(isValidSuccess(data, requestToUpdate, history)),
                    error => dispatch(failure(error))
                )

        } else {
            MiniSitesServices.updateMiniSites(requestToUpdate)
                .then(
                    data => dispatch(updateSuccess(data, history)),
                    error => dispatch(failure(error))
                )
        }
    };

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function isValidSuccess(data, requestToUpdate, history) {
        if (data.data) {
            return {
                type: MiniSitesConstants.FETCH_MINI_SITES_GET_ISVALID,
                payload: data.data
            };
        } else {
            return dispatch => {
                MiniSitesServices.updateMiniSites(requestToUpdate)
                    .then(
                        data => dispatch(updateSuccess(data, history)),
                        error => dispatch(failure(error))
                    )
            }
        }
    }

    function updateSuccess(data, history) {

        history.push('/LayoutMiniSite/List')

        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_UPDATE_SUCCESS,
            payload: true
        };
    }

    function failure(error) {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_ERROR,
            error: error,
        };
    }
}

function fetchMiniSiteClear() {

    return dispatch => {
        dispatch(request());
        return dispatch(success());
    }

    function request() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_PENDING
        };
    }

    function success() {
        return {
            type: MiniSitesConstants.FETCH_MINI_SITES_CLEAR,
        };
    }
}